import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useFirebaseContext } from '../../../context';
import * as ROUTES from '../../../constants';
import { Core } from '../..';
import { DEFAULT_COLOR, DEFAULT_COLORL2 } from '../../../constants';
import { FaEnvelope, FaUserAlt } from 'react-icons/fa';
import { googleAuthProvider, timestamp } from '../../../lib';
import { useMediaQuery } from 'react-responsive';
import { BottomLink } from './styles';
import { getDate } from '../../../helpers';

export default function Signup({
  showSignUpBox,
  setShowSignUpBox,
  setShowSignInBox,
}) {
  const history = useHistory();
  const { firebase } = useFirebaseContext();
  const [firstName, setFirstName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [progress, setProgress] = useState(0);
  const isInvalid = firstName === '' || password === '' || emailAddress === '';

  useEffect(() => {
    if (!showSignUpBox) {
      setError('');
    }
  }, [showSignUpBox]);

  const setWelcomeLists = (passedUser) => {
    if (passedUser.additionalUserInfo.isNewUser) {
      const userDB = firebase
        .firestore()
        .collection('users')
        .doc(firebase.auth().currentUser.uid);
      const taskDB = userDB.collection('tasks');
      const listDB = userDB.collection('lists');
      const tempModifiedAt = timestamp.now().toMillis();

      const tempList = {
        order: 0,
        name: 'Hello 👋',
        color: 0,
        taskCount: 2,
        modifiedAt: tempModifiedAt,
      };

      listDB.add(tempList).then((doc) => {
        listDB.add({
          order: 1,
          name: 'Personal 😎',
          color: 2,
          taskCount: 0,
          modifiedAt: tempModifiedAt,
        });

        listDB.add({
          order: 2,
          name: 'Reading List 📚',
          color: 4,
          taskCount: 0,
          modifiedAt: tempModifiedAt,
        });

        listDB.add({
          order: 3,
          name: 'Fitness 💪',
          color: 6,
          taskCount: 0,
          modifiedAt: tempModifiedAt,
        });

        listDB.add({
          order: 4,
          name: 'Shopping 🛒',
          color: 8,
          taskCount: 0,
          modifiedAt: tempModifiedAt,
        });

        tempList.docID = doc.id;

        const listPrompt = {
          order: 0,
          important: false,
          listID: tempList.docID,
          title: 'Create a new List 🏷️',
          note: '',
          date: getDate(true, new Date()),
          time: '',
          modifiedAt: tempModifiedAt,
        };

        const taskPrompt = {
          order: 1,
          important: false,
          listID: tempList.docID,
          title: 'Create a new Task 📌',
          note: '',
          date: getDate(true, new Date()),
          time: '',
          modifiedAt: tempModifiedAt,
        };

        taskDB.add(listPrompt).then(() => {
          taskDB.add(taskPrompt).then(() => {
            history.push('/');
            history.push(ROUTES.DASHBOARD);
          });
        });
      });
    }
  };
  
  const handleSignUp = (event) => {
    event.preventDefault();
    setProgress(95);

    firebase
      .auth()
      .createUserWithEmailAndPassword(emailAddress, password)
      .then((result) => {
        result.user.updateProfile({
          displayName: firstName,
        });
        setWelcomeLists(result);
      })
      .catch((error) => {
        setProgress(100);
        setFirstName('');
        setEmailAddress('');
        setPassword('');
        setError(error.message);
      });
  };

  const handleGuestSignIn = () => {
    setProgress(95);
    firebase
      .auth()
      .signInAnonymously()
      .then((result) => {
        result.user.updateProfile({
          displayName: 'Guest',
        });
        setWelcomeLists(result);
      })

      .catch((error) => {
        setProgress(100);
        setError(error.message);
      });
  };

  return (
    <>
      <Core.Loading
        color={DEFAULT_COLOR}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />

      <Core.CardContainer
        showBox={showSignUpBox}
        setShowBox={setShowSignUpBox}
        width='25vw'
        minWidth='392px'
      >
        <Core.Title>Sign Up.</Core.Title>

        <Core.ListLayout>
          {showSignUpBox && error != '' && <Core.Error>{error}</Core.Error>}
          <Core.Input
            autoFocus
            placeholder='Username'
            value={firstName}
            style={{ marginBottom: '10px' }}
            onChange={({ target }) => setFirstName(target.value)}
          />

          <Core.Input
            placeholder='Email address'
            style={{ marginBottom: '10px' }}
            value={emailAddress}
            onChange={({ target }) => setEmailAddress(target.value)}
          />

          <Core.Input
            type='password'
            placeholder='Password'
            autoComplete='off'
            style={{ marginBottom: '10px' }}
            value={password}
            onChange={({ target }) => setPassword(target.value)}
          />

          <Core.Button
            color={'white'}
            bg={DEFAULT_COLOR}
            style={{ marginBottom: '25px' }}
            disabled={isInvalid}
            onClick={(e) => {
              setError('');
              handleSignUp(e);
            }}
          >
            <div
              style={{
                width: '100%',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <FaEnvelope
                style={{ height: '100%', position: 'absolute', left: 0 }}
              />
              <span>Sign Up</span>
            </div>
          </Core.Button>

          <Core.Button
            color={DEFAULT_COLOR}
            bg={DEFAULT_COLORL2}
            shadowBorder={true}
            style={{ marginBottom: '10px' }}
            type='button'
            onClick={() => {
              setError('');
              firebase
                .auth()
                .signInWithPopup(googleAuthProvider)
                .then((result) => {
                  setWelcomeLists(result);
                })
                .catch((error) => {
                  setError(error.message);
                });
            }}
          >
            <div
              style={{
                width: '100%',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <img
                src='https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg'
                style={{ height: '100%', position: 'absolute', left: 0 }}
              />
              {useMediaQuery({
                maxWidth: 322,
              }) ? (
                <span>Google</span>
              ) : (
                <span>Sign in with Google</span>
              )}
            </div>
          </Core.Button>

          <Core.Button
            color={DEFAULT_COLOR}
            bg={DEFAULT_COLORL2}
            shadowBorder={true}
            type='button'
            onClick={() => {
              setError('');
              handleGuestSignIn();
            }}
          >
            <div
              style={{
                width: '100%',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <FaUserAlt
                style={{ height: '100%', position: 'absolute', left: 0 }}
              />
              {useMediaQuery({
                maxWidth: 322,
              }) ? (
                <span>Guest</span>
              ) : (
                <span>Sign in as Guest</span>
              )}
            </div>
          </Core.Button>

          <BottomLink
            style={{
              marginTop: '24px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <span style={{ opacity: 0.55, marginRight: '10px' }}>
              Already have an account?
            </span>
            <Core.Link
              onClick={() => {
                setShowSignUpBox(false);
                setShowSignInBox(true);
              }}
            >
              Sign in
            </Core.Link>
          </BottomLink>
        </Core.ListLayout>
      </Core.CardContainer>
    </>
  );
}
